import React from "react";
import { FiArrowRight, FiMessageSquare } from "react-icons/fi";
import "./GlobalCTA.css";

const GlobalCTA = ({
  badge = "Let’s Build Something Exceptional",
  title = "Ready to Start Your Next",
  highlight = "Digital Project?",
  subtitle = "Partner with a global software team delivering scalable web, mobile, and enterprise solutions across India, Dubai, and worldwide.",
  primaryText = "Start a Project",
  primaryLink = "/start-project",
  secondaryText = "Talk to an Expert",
  secondaryLink = "/contact",
}) => {
  return (
    <section className="oglitz-global-cta">
      <div className="oglitz-global-cta__inner">
        <span className="oglitz-global-cta__badge">{badge}</span>

        <h2 className="oglitz-global-cta__title">
          {title} <span>{highlight}</span>
        </h2>

        <p className="oglitz-global-cta__subtitle">{subtitle}</p>

        <div className="oglitz-global-cta__actions">
          <a href={primaryLink} className="oglitz-global-cta__primary-btn">
            {primaryText} <FiArrowRight />
          </a>

          <a href={secondaryLink} className="oglitz-global-cta__secondary-btn">
            <FiMessageSquare />
            {secondaryText}
          </a>
        </div>

        <p className="oglitz-global-cta__trust">
          Trusted by startups, enterprises & global brands
        </p>
      </div>
    </section>
  );
};

export default GlobalCTA;
